import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";
import HubspotFormContainer from "components/HubspotFormContainer";

export const HubspotForm = ({
  className,
  content,
  hubSpotPortalId,
  hubSpotFormId = null,
  successPageUrl = null,
  divider,
  fullWidth,
  logo
}) => {

  if (!hubSpotFormId) {
      return null;
  }

  return (
    <section id="form" className={`${styles.root} ${className}`}>
      {!fullWidth && logo && (
        <span className="overlayBg position-absolute">
          <img src="/site-assets/svg/branded-logo.svg" alt="Branded Logo" />
        </span>
      )}

      <Container className="position-relative py-4 py-md-5">
        {divider && <hr className="pt-5" />}
        {fullWidth ? (
          <HubspotFormContainer portal_id={hubSpotPortalId} form_id={hubSpotFormId} successPageUrl={successPageUrl} />
        ) : (
          <Row>
            <Col md={6} className="pe-md-5 mb-4 mb-md-0">
              {content && <div dangerouslySetInnerHTML={{ __html: content }} />}
            </Col>
            <Col md={6} className="ps-md-5">
              <HubspotFormContainer portal_id={hubSpotPortalId} form_id={hubSpotFormId} />
            </Col>
          </Row>
        )}
      </Container>
    </section>
  );
};

export default HubspotForm;
